module.exports = __webpack_public_path__ + "static/img/6.6ee83c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/zh/6.png
// module id = u587
// module chunks = 0